export const questionNames = {
  NODE_VERSION_CATEGORY: 'nodeVersionCategory',
  PACKAGE_MANAGER: 'packageManager',
  PROJECT_TYPE: 'projectType',
  PROJECT_TYPE_CHOICE: 'projectTypeChoice',
  SHOULD_BE_SCOPED: 'shouldBeScoped',
  SCOPE: 'scope',
  AUTHOR_NAME: 'authorName',
  AUTHOR_EMAIL: 'authorEmail',
  AUTHOR_URL: 'authorUrl',
  HOST: 'host',
  CONFIGURE_LINTING: 'configureLint',
  DIALECT: 'dialect'
};
